<script>
export default {
    name: "UploadImages",
    props: {
        resource: {
            required: true
        },
        id: {
            required: true
        },
    },
    data() {
        return {
            loading: false,
            images: [],
            headersUpload: {
                'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
            },
            dialogImageUrl: '',
            dialogVisible: false
        }
    },
    async mounted() {
        await this.getImages();
    },
    methods: {
        async getImages() {
            this.loading = true;
            let response = await axios.get('/pro/pictures/' + this.resource + '/' + this.id);
            this.images = response.data;
            this.loading = false;
        },
        async handleRemove(file, fileList) {
            this.loading = true;
            let response = await axios.delete('/pro/pictures/' + this.resource + '/' + this.id + '/' + file.id);
            fileList = response.data;
            this.loading = false;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSuccess(response, file, fileList) {
            response.forEach((item) => {
                if(!this.images.find((image) => image.id === item.id)) {
                    this.images.push(item);
                }
            });
        }
    }
}
</script>

<template>
    <div class="image-uploader">
        <el-upload
            ref="upload"
            :action="'/pro/pictures/' + resource + '/' + id"
            accept="image/jpg,image/jpeg,image/png,image/webp"
            :file-list="images"
            :headers="headersUpload"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-success="handleSuccess"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog fullscreen :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<style lang="scss">
.image-uploader .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: cover;
}
</style>
